// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3yfgg","footer":"ReportModalFilter_footer__1ZKEz"};